import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import VwSoLineDetail from '../entities/sales-orders/vw-so-line'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface VwSoLineState extends ListState<VwSoLineDetail> {
    totalCount: number,
    currentPage: number,
    pageSize: number,
    list: Array<VwSoLineDetail>,
    loading: boolean,
}
class VwSoLineModule extends ListModule<VwSoLineState, any, VwSoLineDetail>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<VwSoLineDetail>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<VwSoLineState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/VwSoLine/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<VwSoLineDetail>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
       
    };
    mutations = {
        setCurrentPage(state: VwSoLineState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: VwSoLineState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}
const vwSoLineModule = new VwSoLineModule();
export default vwSoLineModule;